import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './YayinOlanaklari.css';

function YayinOlanaklari() {
  const dergiler = [
    { ad: "Uluslararası İşletme ve Ekonomi Çalışmaları Dergisi", link: "https://dergipark.org.tr/tr/pub/uiecd", indeks: "SCOPUS ve TR DİZİN", kosul: "Seçilen 15 bildiri İngilizce olarak hakem surecleri sonrasında yayımlanacaktır" },
    { ad: "İş ve İnsan Dergisi", link: "https://dergipark.org.tr/tr/pub/iid", indeks: "TR DİZİN", kosul: "Seçilen 3 adet bildiri hakem sureçleri sonrasında ücretsiz yayımlanacaktır" },
    { ad: "İş Güç Dergisi", link: "https://dergipark.org.tr/tr/pub/iid", indeks: "EBSCO ", kosul: "Başvuran makalelerden hakem süreçleri sonrasında özel sayı yayimlanacaktır" },
    { ad: "Kırıkkale Üniversitesi Sosyal Bilimler Dergisi", link: "https://dergipark.org.tr/tr/pub/kusbd", indeks: "EBSCO ", kosul: "Başvuran ilk 10 bildiri hakem süreci sonrasında yayımlanacaktır" },

    { ad: "İstanbul İktisat Dergisi", link: "https://dergipark.org.tr/tr/pub/istjecon", indeks: "TR DİZİN", kosul: "Seçilen 6 adet bildiri tam metni hakem süreci sonrası yayına kabul edilecektir." },
    { ad: "Social Mucit Academic Review", link: "https://dergipark.org.tr/tr/pub/smar/", indeks: "TR DİZİN", kosul: "Seçilen 5 adet bildiri tam metni hakem süreci sonrasında ücretsiz olarak yayınlanacaktır." },
    { ad: "İşletme Bilimi Dergisi", link: "https://dergipark.org.tr/tr/pub/jobs", indeks: "TRDİZİN", kosul: "En az 10 bildiri süreçleri geçerse 2026 Özel Sayısında yayınlanması planlanmaktadır." },
    { ad: "Yönetim ve Organizasyon Araştırmaları Dergisi", link: "https://betadergi.com/yoad/index.php", indeks: "TRDİZİN", kosul: "Başvuran ilk 10 bildiri arasından hakemlik sürecini geçenler yayınlanacaktır. En az 3 makale ile Özel Sayı planlanmaktadır." },
    { ad: "Journal of Management Archive", link: "https://jomajournal.org/", indeks: "Crossref, Harvard Library, WorldCat", kosul: "İlk 10 bildiri arasından hakemlik sürecini geçenler yayınlanacaktır. Sadece İngilizce başvurular kabul edilir." },
    { ad: "Journal of Organizational Behavior Review", link: "https://dergipark.org.tr/tr/pub/jobreview", indeks: "Erih Plus, WORLDCAT, CITE FACTOR, SIS", kosul: "Hakem sürecinden olumlu geçen kongre bildirileri ilk sayıda yayınlanacaktır." },
    { ad: "Örgütsel Davranış Çalışmaları Dergisi", link: "https://obstudies.org", indeks: "Erih Plus, ASOS, SIS, ISI, ESJI", kosul: "Başvuran ilk 10 bildiri arasından hakemlik sürecini geçenler yayınlanacaktır." },
    { ad: "Sakarya Üniversitesi İşletme Enstitüsü Dergisi", link: "https://dergipark.org.tr/tr/pub/sauied", indeks: "Erih Plus, DOAJ, EBSCO, CEAS", kosul: "Hakemlik sürecini geçen ilk 10 bildiri yayınlanacaktır. 5 makale ile Özel Sayı planlanabilir." },
    { ad: "Stratejik Yönetim Araştırmaları Dergisi", link: "https://journalofstrategy.org/", indeks: "Erih Plus, ASOS, SIS, ISI", kosul: "Süreci geçen ilk 10 bildiri yayınlanacaktır. 4 makale ile Özel Sayı planlanabilir." },
    { ad: "Uluslararası Yönetim Akademisi Dergisi", link: "https://dergipark.org.tr/tr/pub/mana", indeks: "Erih Plus, EBSCO, COPERNICUS", kosul: "Başvuran ilk 10 bildiri arasından hakemlik sürecini geçenler ücretsiz yayınlanacaktır." },
    { ad: "Turkish Management Review", link: "https://turmr.com/index.php/turmr", indeks: "COPERNICUS", kosul: "Süreci geçen ilk 10 bildiri yayınlanacaktır. 5 makale ile Özel Sayı planlanabilir." },
    { ad: "Yönetim ve Örgüt Tarihi Dergisi", link: "https://www.managementhistory.org/", indeks: "DRJI, ESJI, ASI", kosul: "Süreci geçen ilk 10 bildiri yayınlanacaktır. 3 makale ile Özel Sayı planlanabilir." },
  ];

  return (
    <div className="yayin-page">
      <Navbar />
      
      <header className="page-hero">
        <div className="container">
          <h2>YAYIN OLANAKLARI</h2>
          <p>34. Ulusal Yönetim ve Organizasyon Kongresi</p>
        </div>
      </header>

      <main className="content-container">
        <div className="disclaimer-box">
          <p><i className="fas fa-exclamation-circle"></i> Düzenleme Kurulu, aşağıdaki dergileri katılımcılara öneri olarak sunmaktadır. Bu süreçteki rolümüz yalnızca aracılık düzeyinde olup, herhangi bir yayın garantisi söz konusu değildir.</p>
          <p>Makalelerin yayımlanabilmesi, dergilerin kendi editöryal ve hakem değerlendirme süreçlerinden başarılı geçmelerine bağlıdır.</p>
        </div>

        <div className="table-wrapper">
          <table className="yayin-table">
            <thead>
              <tr>
                <th>Dergi Adı</th>
                <th>Tarandığı İndeksler</th>
                <th>Yayın Koşulları</th>
                <th>Link</th>
              </tr>
            </thead>
            <tbody>
              {dergiler.map((dergi, index) => (
                <tr key={index}>
                  <td className="dergi-name">{dergi.ad}</td>
                  <td className="dergi-indeks">{dergi.indeks}</td>
                  <td className="dergi-kosul">{dergi.kosul}</td>
                  <td className="text-center">
                    <a href={dergi.link} target="_blank" rel="noopener noreferrer" className="visit-btn">
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="important-footer-notes">
          <div className="note-card">
            <h4>Önemli Not:</h4>
            <p>Makaleye dönüştürülmüş bildiri metinleri dergi sistemlerine yüklenirken, <strong>“34. Ulusal Yönetim ve Organizasyon Kongresi’nde sunulmuş ve özet bildiriler kitabında yayınlanmıştır”</strong> notu düşülmelidir.</p>
            <p>Araştırmacılar ilgili dergilere bireysel olarak başvuru yapabilecek ve süreci kendileri yürüteceklerdir.</p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default YayinOlanaklari;